// src/components/task/TaskCommentApi.tsx
import axios from 'axios';
import { API_ENDPOINTS } from '../../apiConfig';

export interface TaskCommentDTO {
    id: string;                              // UUID
    taskId: string;                          // UUID
    userId: string;                          // UUID
    tenantId: string;                        // UUID
    employeeId: string;                      // UUID
    employeeName: string;
    userName: string;
    content: string;
    parentId: string | null;                 // UUID or null for top-level comments
    isInternal: boolean;
    visibility: string;
    edited: boolean;
    editedAt: string | null;                 // ISO date string or null
    editedBy: string | null;                 // UUID or null
    deletedBy: string | null;                // UUID or null
    deletedAt: string | null;                // ISO date string or null
    isDeleted: boolean;
    createdAt: string;                       // ISO date string
    createdBy: string;
    updatedAt: string;
    updatedBy: string;
    children: TaskCommentDTO[];             // Recursive list of child comments
  }

   
export interface TaskCommentFilterDTO {
    taskId?: string; // UUID
    tenantId?: string; // UUID
    userId?: string; // UUID
    userName?: string;
    content?: string;
    isInternal?: boolean;
    isDeleted?: boolean;
    visibility?: string; //'PUBLIC' | 'PRIVATE' | 'INTERNAL';
    createdFrom?: string; // ISO date string e.g. "2025-07-26T12:00:00Z"

    createdTo?: string;
}

const API_BASE = `${API_ENDPOINTS.project}/task-comments`;

export const TaskCommentApi = {
  create: (data: TaskCommentDTO) => axios.post(`${API_BASE}`, data),
  update: (id: string, data: TaskCommentDTO) => axios.put(`${API_BASE}/${id}`, data),
  delete: (id: string) => axios.delete(`${API_BASE}/${id}`),
  getById: (id: string) => axios.get(`${API_BASE}/${id}`),
  filter: (filter: TaskCommentFilterDTO) => axios.post(`${API_BASE}/filter`, filter),
};